"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientHydration = exports.loadCodesplitIfNeeded = exports.startApplication = void 0;
var bernie_l10n_1 = require("bernie-l10n");
var bernie_core_1 = require("bernie-core");
var bernie_view_1 = require("bernie-view");
var get_client_plugins_1 = require("bernie-plugins/dist/load/get-client-plugins");
var browser_1 = require("bernie-plugins/dist/execute/browser");
var queryString = require("query-string");
var React = require("react");
var react_dom_1 = require("react-dom");
var react_router_dom_1 = require("react-router-dom");
var bernie_client_events_1 = require("../../events/bernie-client-events");
var logger_1 = require("../../logger");
var loader_1 = require("./brand/loader");
var controller_life_cycle_1 = require("./controller-life-cycle");
var logger = logger_1.ClientLogger.getLoggerWithIdentifier('bernie.client.hydrate');
exports.startApplication = logTime(bernie_client_events_1.BERNIE_CLIENT_EVENTS.APP_HYDRATION_COMPLETE)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var plugins, contextPlugin, state, l10nModule, appData, l10n, stores, controllers, pageDataContext, context, _a, baseUrl, appName, matchedRoute, route, component, storeContainer, routes, appContainerId, renderApp, appContainer, deviceInformation, brandConfig, brandData, Providers, wrapRootElementResult, RootElement;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                logHydrationStarting();
                preventShortTermDialogOpening();
                pseudoStylingFixForSafari();
                plugins = (0, get_client_plugins_1.getClientPlugins)();
                contextPlugin = 'context';
                state = window.__PLUGIN_STATE__;
                l10nModule = { formatText: bernie_l10n_1.formatText, formatDate: bernie_l10n_1.formatDate, formatDateString: bernie_l10n_1.formatDateString, getWeekData: bernie_l10n_1.getWeekData, parseLocalDateString: bernie_l10n_1.parseLocalDateString, setLocale: bernie_l10n_1.setLocale };
                if (state[contextPlugin]) {
                    l10nModule.setLocale(state[contextPlugin].context.locale);
                }
                return [4 /*yield*/, (0, browser_1.onBrowserHydrateRenderContext)(plugins, {
                        appData: { l10n: l10nModule },
                        logger: logger,
                        state: window.__PLUGIN_STATE__,
                    })];
            case 1:
                appData = (_b.sent()).appData;
                l10n = appData.l10n, stores = appData.stores, controllers = appData.controllers, pageDataContext = appData.pageDataContext, context = appData.context;
                _a = pageDataContext || {}, baseUrl = _a.baseUrl, appName = _a.appName;
                matchedRoute = (0, bernie_core_1.matchRoute)(controllers, location.pathname, { baseUrl: baseUrl });
                route = matchedRoute.route;
                component = route.component;
                storeContainer = new bernie_core_1.StoreContainer(stores);
                routes = controllers.map(function (controller) {
                    return (0, controller_life_cycle_1.setupControllerLifeCycleCallbacks)(appData, baseUrl, storeContainer, controller, logger);
                });
                return [4 /*yield*/, loadCodesplitIfNeeded(component)];
            case 2:
                _b.sent();
                appContainerId = appName ? "app-".concat(appName) : 'app';
                renderApp = function (props) { return React.createElement(bernie_view_1.Application, __assign({}, props, { routes: routes, applicationContainerId: appContainerId })); };
                appContainer = document.getElementById(appContainerId);
                deviceInformation = context === null || context === void 0 ? void 0 : context.deviceInformation;
                return [4 /*yield*/, (0, loader_1.loadBrandData)(logger, context === null || context === void 0 ? void 0 : context.site.brand)];
            case 3:
                brandConfig = _b.sent();
                brandData = (0, bernie_core_1.getBrandConfiguration)(brandConfig);
                Providers = (0, bernie_core_1.getProviders)({
                    localization: l10n,
                    loggerFactory: logger_1.ClientLogger.getLoggerWithIdentifier,
                    deviceInformation: deviceInformation,
                    brandData: brandData,
                });
                return [4 /*yield*/, (0, browser_1.onBrowserWrapRootElement)(plugins, {
                        appData: appData,
                        logger: logger,
                    })];
            case 4:
                wrapRootElementResult = _b.sent();
                RootElement = wrapRootElementResult.result.RootElement;
                (0, react_dom_1.hydrate)(React.createElement(react_router_dom_1.BrowserRouter, { basename: baseUrl },
                    React.createElement(Providers, null,
                        React.createElement(RootElement, null,
                            React.createElement(react_router_dom_1.Route, { render: renderApp })))), appContainer, function () {
                    // Final fallback check should everything blow up
                    if (appContainer && appContainer.innerHTML === '') {
                        appContainer.innerHTML = bernie_view_1.Application.fallbackContent || '';
                    }
                });
                return [2 /*return*/];
        }
    });
}); });
function preventShortTermDialogOpening() {
    // Prevent Short-Term dialogs from reopening on page-load
    var dialogKeys = ['pwaDialogNested', 'pwaDialog', 'pwaOverlay'];
    var PWA_DIALOG_REGEX = /pwaDialog\w*=[^&]*&?/g;
    if (typeof history !== 'undefined') {
        var query = queryString.parse(location.search);
        var hasPwaDialog = Object.keys(query).some(function (key) { return dialogKeys.indexOf(key) >= 0; });
        if (hasPwaDialog) {
            var urlSansDialog = location.toString().replace(PWA_DIALOG_REGEX, '');
            history.replaceState(null, document.title || '', urlSansDialog);
        }
        else {
            // re-initialize the history stack for some weird bug on iOS coming from Trivago or Kayak
            history.replaceState(history.state || {}, document.title || '');
        }
    }
}
function logHydrationStarting() {
    logger.logEvent(bernie_client_events_1.BERNIE_CLIENT_EVENTS.APP_HYDRATION_START, {
        pageHydrated: typeof window === 'object' && window.performance && window.performance.now ? window.performance.now() : null,
    });
}
function logTime(event) {
    function getTime() {
        return typeof window === 'object' && window.performance && window.performance.now
            ? window.performance.now()
            : Date.now();
    }
    return function (func) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var startTime, endTime;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            startTime = getTime();
                            return [4 /*yield*/, func.apply(this, args)];
                        case 1:
                            _a.sent();
                            endTime = getTime();
                            logger.logEvent(event, {
                                time: "".concat(endTime - startTime),
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
    };
}
function loadCodesplitIfNeeded(component) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(component.prototype instanceof bernie_core_1.CodeSplit && component.componentLoaded !== true)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, component.loadRoute()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.logEvent(bernie_client_events_1.BERNIE_CLIENT_EVENTS.COMPONENT_LOAD_ROUTE_ERROR, error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.loadCodesplitIfNeeded = loadCodesplitIfNeeded;
function pseudoStylingFixForSafari() {
    /*
     * Allow pseudo styling to work in mobile safari. For more information about matching desktop behavior in safari mobile, see:
     * https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/AdjustingtheTextSize/AdjustingtheTextSize.html#//apple_ref/doc/uid/TP40006510-SW5
     */
    document.addEventListener('touchstart', function () { }, true);
}
var clientHydration = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.startApplication)()];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.clientHydration = clientHydration;
//# sourceMappingURL=hydrate.js.map